const en = {
  Signin: "Signin",
  Signup: "Signup",
  Setting: "Setting",
  Logout: "Logout",
  Welcome: "Welcome",
  Name: "Name",
  Email: "Email",
  Message: "Message",
  "Start the success of your website with us":
    "Start the success of your website with us",
  Send: "Send",
  "Let's talk": "Let's talk",
  Features: "Features",
  "About Us": "About Us",
  Pricing: "Pricing",
  Home: "Home",
  USD: "USD",
  month: "month",
  "Billed Monthly": "Billed Monthly",
  "Billed Yearly": "Billed Yearly",
  Monthly: "Monthly",
  Yearly: "Yearly",
  "Quick links":"Quick links",
  "Head Office":"Head Office",
  "3041 Alasaker St an nuzha Riyadh":"3041 Alasaker St an nuzha Riyadh",
  "All rights reserved":"All rights reserved",
  "Features That Live Up To Your Taste And Enable You To Work":
    "Features That Live Up To Your Taste And Enable You To Work",
  "With A Few Clicks, You Will Have Launched Your Electronic Identity In The Internet Space, With An Unprecedented Quality That Has Been Meticulously Developed To Meet The Most Important Details.":
    "With A Few Clicks, You Will Have Launched Your Electronic Identity In The Internet Space, With An Unprecedented Quality That Has Been Meticulously Developed To Meet The Most Important Details.",
  "Technology developed from scratch": "Technology developed from scratch",
  "You can directly sell your service or product":
    "You can directly sell your service or product",
  "Your service or product can be added and made available to your customers without complications.":
    "Your service or product can be added and made available to your customers without complications.",
  "With ease, enjoy personalized mail for your business":
    "With ease, enjoy personalized mail for your business",
  "Add your custom mail to your domain and to all your employees without the need for a specialist.":
    "Add your custom mail to your domain and to all your employees without the need for a specialist.",
  "The development was carried out with international technologies, and you also made custom development with expert touches to be unique in high performance.":
    "The development was carried out with international technologies, and you also made custom development with expert touches to be unique in high performance.",
  Guest: "Guest",
  "Customize your website": "Customize your website",
  "Buy your domain": "Buy your domain",
  "Start Creating Today!": "Start Creating Today!",
  "Your landing page with ease and show up to your  customers in a professional way":
    "Your landing page with ease and show up to your  customers in a professional way",
  "Get Started": "Get Started",
  "Simply put, prices that match your budget":
    "Simply put, prices that match your budget",
  "Enjoy the monthly or annual plan, with suitable features and functions, at prices that suit everyone.":
    "Enjoy the monthly or annual plan, with suitable features and functions, at prices that suit everyone.",
  "Basic Plan": "Basic Plan",
  "Standard Plan": "Standard Plan",
  "Advanced Plan": "Advanced Plan",
  Select: "Select",
  Recomended: "Recomended",
  "Our company's identity and actions": "Our company's identity and actions",
  "Who We Are": "Who We Are",
  "We are a trusted platform that bridges the gap between individuals or businesses and their online presence. Our mission is to empower clients to create, customize, and control their online identity with minimal effort. Whether you're looking to buy a domain, use an existing one, or launch a fully customizable website, our platform provides the tools, support, and flexibility to make it happen. We are more than just a service provider; we are your partner in building a powerful online presence, ensuring scalability, security, and ease of use.":
    "We are a trusted platform that bridges the gap between individuals or businesses and their online presence. Our mission is to empower clients to create, customize, and control their online identity with minimal effort. Whether you're looking to buy a domain, use an existing one, or launch a fully customizable website, our platform provides the tools, support, and flexibility to make it happen. We are more than just a service provider; we are your partner in building a powerful online presence, ensuring scalability, security, and ease of use.",
  "Our Services": "Our Services",
  "Domain Services": "Domain Services",
  "Domain Purchase:": "Domain Purchase: ",
  "Help clients search, purchase, and secure their perfect domain.":
    "Help clients search, purchase, and secure their perfect domain.",
  "Domain Transfer:": "Domain Transfer: ",
  "Seamless transfer of existing domains to our platform with 24/7 support.":
    "Seamless transfer of existing domains to our platform with 24/7 support.",
  "Domain Management:": "Domain Management: ",
  "Tools to manage DNS settings, subdomains, and email setups.":
    "Tools to manage DNS settings, subdomains, and email setups.",
  "Website Creation": "Website Creation",
  "Pre-Built Templates:": "Pre-Built Templates: ",
  "Hosting Services": "Hosting Services",
  "Scalable Hosting Plans:": "Scalable Hosting Plans: ",
  "Content Management": "Content Management",
  "Built-In CMS:": "Built-In CMS: ",
  "Social Media Integration:": "Social Media Integration:",
  "Customer can integrate social media accounts for website.":
    "Customer can integrate social media accounts for website.",
  "A library of professionally designed templates for every industry.":
    "A library of professionally designed templates for every industry.",
  "From shared hosting to dedicated servers.":
    "From shared hosting to dedicated servers.",
  "One-Click Installations:": "One-Click Installations:",
  "CDN Integration:": "CDN Integration:",
  "Install popular platforms like WordPress, Joomla, or Magento with ease.":
    "Install popular platforms like WordPress, Joomla, or Magento with ease.",

  "Speed up your site with integrated content delivery networks.":
    "Speed up your site with integrated content delivery networks.",
  "Manage content easily through our intuitive dashboard.":
    "Manage content easily through our intuitive dashboard.",
  "SEO Tools:": "SEO Tools:",
  "Integrated tools to help your website rank higher on search engines.":
    "Integrated tools to help your website rank higher on search engines.",
  "E-Commerce Features:": "E-Commerce Features:",
  "Enable online stores with payment gateways, inventory management, and more.":
    "Enable online stores with payment gateways, inventory management, and more.",
    "Email is required": "Email is required",
    "Message is required": "Message is required",
    "Name is required": "Name is required",
    "Name must be at least 3 characters long":"Name must be at least 3 characters long",
};
export default en;
